// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3ljTa","list":"PatternAutocomplete_list__RWGw5"};